export const ccTypeToCode = {
  VISA: '001',
  MASTERCARD: '002',
  AMERICANEXPRESS: '003',
  DISCOVER: '004',
  CHINAUNIONPAY: '005',
  UNIONPAY: '005',
  JCB: '006',
  DINERS: '007',
  DINERSCLUB: '007',
  XBUCK: '100',
};

export const ccCodeToType = {
  '001': 'Visa',
  '002': 'MasterCard',
  '003': 'AMEX',
  '004': 'Discover',
  '005': 'ChinaUnionPay',
  '006': 'JCB',
  '007': 'DinersClub',
  100: 'XBUCK',
};

export function getCcTypeCode(type) {
  if (!type) return type;
  const normalized = type.replace(/[\s_-]/g, '').toUpperCase();
  return ccTypeToCode[normalized] || type;
}

export function getCcTypeString(code) {
  return ccCodeToType[code] || code;
}
